import { Ruler, Users, HeartHandshake } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

const icons = [Ruler, Users, HeartHandshake];

const FrictionReducers = () => {
  const { language } = useLanguage();
  const t = translations[language].friction;

  return (
    <section className="border-y border-border py-12 sm:py-20" aria-labelledby="friction-heading">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 id="friction-heading" className="sr-only">
          {language === "nl" ? "Waarom PlayfieldVR zonder zorgen werkt" : "Why PlayfieldVR works without hassle"}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 max-w-5xl mx-auto">

          {t.items.map((item, idx) => {
            const Icon = icons[idx];
            return (
              <div key={item.title} className="flex flex-col items-start gap-3">
                <Icon className="w-5 h-5 text-primary shrink-0" />
                <h3 className="text-base sm:text-lg font-semibold tracking-tight">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FrictionReducers;
